import Api from "@/network/api";
import { defineStore } from "pinia";
import { httpRequest } from "@/network/request";
import Cookie from "@/utils/cookie";
import StorageHelper from "@/utils/storageHelper";
import type { UserInfo } from "@/types/store";
import Util from "@/utils/util";
import AppProtocol from "@/utils/appProtocol";

export interface UserState {
  isLogin: 0 | 1;
  isLoginInitialized: boolean;
  isVip: boolean;
  userInfo: UserInfo;
  headerInfo: Record<string, any>;
  integral: number;
  isNoReceiveVoucher: boolean;
}

export const useUserStore = defineStore("user", {
  state: (): UserState => ({
    isLogin: 0,
    isLoginInitialized: false,
    isVip: false,
    userInfo: {} as UserInfo,
    headerInfo: {},
    integral: 0,
    isNoReceiveVoucher: false,
  }),

  getters: {
    getUserInfo: (state) => state.userInfo,
    getAccountIntegral: (state) => state.integral,
    getIsNoReceiveVoucher: (state) => state.isNoReceiveVoucher,
  },

  actions: {
    setLoginState(isLoggedIn: 0 | 1) {
      this.isLogin = isLoggedIn;
      this.isLoginInitialized = true;
      StorageHelper.set("isLogin", isLoggedIn);
    },

    setVipState(isVip: boolean) {
      this.isVip = isVip;
    },

    setHeaderInfo(headerInfo: Record<string, any>) {
      try {
        console.log("------ set header cookie(Client_EncryptType, ClientHeaderInfo, Client_ProductID) ------");
        const { enCryptType, EncryptType, headInfo, ClientHeaderInfo, productId, ProductID, domain = ".babybus.com", path = "/" } = headerInfo;

        Cookie.set("Client_EncryptType", enCryptType || EncryptType, {
          path,
          domain,
          expires: 172800,
        });
        Cookie.set("ClientHeaderInfo", headInfo || ClientHeaderInfo, {
          path,
          domain,
          expires: 172800,
        });
        Cookie.set("Client_ProductID", productId || ProductID, {
          path,
          domain,
          expires: 172800,
        });
      } catch (error) {
        console.error("setHeaderInfo error", error);
      }
      this.headerInfo = headerInfo;
    },

    fetchUserInfo() {
      return httpRequest({ apiInfo: Api.GetUserInfo }).then(
        (res: UserInfo) => {
          this.userInfo = res || {};
          return res;
        },
        (err) => {
          console.error("获取用户信息失败", err);
        },
      );
    },

    fetchAccountIntegral() {
      return httpRequest({ apiInfo: Api.GetAccountIntegral }).then(
        (res) => {
          this.integral = res.integral || 0;
          return res; // 返回结果
        },
        (err) => {
          console.error("获取用户积分失败", err);
          return Promise.reject(err); // 抛出错误，方便调用方捕获
        },
      );
    },

    setReceiveVoucherState(state: UserState, data: boolean) {
      state.isNoReceiveVoucher = data;
    },

    checkLogin() {
      if (this.isLoginInitialized) {
        return Promise.resolve(this.isLogin === 1);
      } else {
        //手动更新用户登录状态，主要场景位于进入的初始页面为需要登录的页面，而登录状态还未初始化时，需要手动更新登录状态
        return new Promise(async (resolve, reject) => {
          const userStore = useUserStore();
          if (Util.isInApp()) {
            const isLogin: boolean = await AppProtocol.isLogin();
            userStore.setLoginState(isLogin ? 1 : 0);
            resolve(isLogin);
          } else if (Util.isInMiniProgram()) {
            const isLogin = Util.getUrlParameterByName("isLogin", location.search);
            userStore.setLoginState(isLogin == "1" ? 1 : 0);
            resolve(isLogin);
          } else {
            resolve(false);
          }
        });
      }
    },
  },
});
